<template>
    <div class="container-fluid section">
        <div class="row heading">
            <div class="col-12 col-lg-3">
                <h2>Cashflow</h2>
            </div>

            <div class="col-12 col-lg-9 text-right">

                <div style="width: 250px; display: inline-block;">
                    <show-hide-cols
                            :cols="cols"
                            :selected="filters.columns"
                    ></show-hide-cols>
                </div>
                <save-report></save-report>

                <save-chart
                        :xOpts="cols"
                        :yOpts="cols"
                        fn="accountCashflow2"
                        :filters="filters"
                ></save-chart>

                <download
                        fn="accountCashflow2"
                        :filters="filters"
                        :cols="cols"
                ></download>

                <button class="btn btn-light" @click="clearFilters"><i class="fa fa-remove"></i> &nbsp;Clear Filters</button>&nbsp;


                &nbsp;&nbsp;
                <paginate
                        :page-count="num_pages"
                        :initial-page="parseInt(filters.page - 1)"
                        :page-range="1"
                        :margin-pages="1"
                        :click-handler="paginateClick"
                        container-class="pagination"
                        page-class="page-item"
                        page-link-class="page-link"
                        prev-class="page-item"
                        prev-link-class="page-link"
                        next-class="page-item"
                        next-link-class="page-link"
                ></paginate>
            </div>
        </div>

        <full-table
                headerClass="table-head"
                filterClass="table-filter table-subhead"
                :cols="cols"
                :data="tableData"
                filterInputClass="form-control"
                :filters="filters"
                @filter="fetch"
        >


            <template slot="account_name_heading" scope="props">
                <span v-tooltip.bottom="metaUnique(meta.account_name)">
                    {{props.value}} <i class="fa fa-info-circle" style="font-size: 12px;"></i>
                </span>
            </template>


            <template slot="carrier_name_heading" scope="props">
                <span v-tooltip.bottom="metaUnique(meta.carrier_name)">
                    {{props.value}} <i class="fa fa-info-circle" style="font-size: 12px;"></i>
                </span>
            </template>

            <template slot="net_billed_heading" scope="props">
                <span v-tooltip.bottom="metaDollar(meta.net_billed)">
                    {{props.value}} <i class="fa fa-info-circle" style="font-size: 12px;"></i>
                </span>
            </template>


            <template slot="commission_heading" scope="props">
                <span v-tooltip.bottom="metaDollar(meta.commission)">
                    {{props.value}} <i class="fa fa-info-circle" style="font-size: 12px;"></i>
                </span>
            </template>






            <template slot="date_posted_filter" scope="props">
                <timeframe
                        :timeframes="timeframes"
                        :groups="groups"
                        v-model="filters.search.date_posted"
                >
                </timeframe>
            </template>


            <pulse-loader style="text-align:center;" slot="loading" v-show="loading" color="#5e9cd3"></pulse-loader>

        </full-table>

    </div>
</template>
<script type="text/babel">
    var Paginate = require('vuejs-paginate');
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import FullTable from '../assets/FullTable.vue';
    import ShowHideCols from '../assets/ShowHideCols.vue';
    import SaveReport from '../assets/SaveReport.vue';
    import SaveChart from '../assets/SaveChart.vue';
    import Download from '../assets/Download.vue';
    import Dropdown from '../assets/Dropdown.vue';
    import MultiSelect from '../assets/MultiSelect.vue';
    import Datepicker from 'vuejs-datepicker';
    import Modal from '../assets/Modal.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    import Timeframe from '../assets/Timeframe.vue';
    import RangeFilter from '../assets/RangeFilter.vue';


    export default {
        name: 'app',
        data () {
            return {
                styleObj:{
                    width: '320px',
                    textAlign: 'right'
                },
                meta: {},
                filters: {
                    search:{
                        date_posted: {
                            timeframe: '',
                            start: '',
                            end: '',
                            group: ''
                        },
                        carrier_name: '',
                        account_name: '',
                        product: '',
                        net_billed: '',
                        commission: '',
                    },
                    sort: [{
                        field: 'date_posted',
                        dir: 'DESC'
                    }],
                    columns:[],
                    limit: 25,
                    page: 1
                },
                num_pages: 0,
                cols:[
                    {
                        key:        'date_posted',
                        display:    'Date Posted',
                        filter:     "Object",
                        sortable:   true,
                        width:      275,
                        sort:       0

                    },
                    {
                        key:        'account_name',
                        display:    'Account Name',
                        filter:     true,
                        sortable:   true,
                        width:      250,
                        sort:       1
                    },
                    {
                        key:        'carrier_name',
                        display:    'Carrier Name',
                        filter:     true,
                        sortable:   true,
                        width:      250,
                        sort:       2
                    },


                    {
                        key:        'product',
                        display:    'Product',
                        filter:     true,
                        sortable:   true,
                        width:      250,
                        sort:       3
                    },


                    {
                        key:        'net_billed',
                        display:    'Net Billed',
                        filter:     true,
                        sortable:   true,
                        width:      250,
                        sort:       4
                    },
                    {
                        key:        'commission',
                        display:    'Comission',
                        filter:     true,
                        sortable:   true,
                        width:      250,
                        sort:       5
                    }

                ],
                timeframes:[ 'Month To Date', 'Last 30 days', 'Last Month', 'Quarter To Date', 'Last Quarter', 'Year To Date', 'Last One Year', 'Last Year', 'Lifetime', 'Custom'],
                groups: [
                    'Date', 'Week', 'Month', 'Year'
                ],
                tableData:[],
                loading: false,
                todaysDate:{
                    to: new Date().setHours(23,59,59,999),
                    from: new Date().setHours(0,0,0,0)
                },
            }
        },
        components:{
            Paginate,
            FullTable,
            PulseLoader,
            ShowHideCols,
            SaveReport,
            Download,
            SaveChart,
            Dropdown,
            Datepicker,
            DropdownConfirmation,
            Modal,
            Timeframe,
            RangeFilter

        },
        created(){

        },

        filters:{
            formatMoney(n){
                if(!n) return ' - ';

                var c = 2,
                        d = '.',
                        t = ',',
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return "$" + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");

            },
            formatInteger(n){
                if(!n) return ' - ';
                var c = 0,
                        d = '.',
                        t = ',',
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
            },
            formatDate(val){
                if(!val) return '';
                return moment(val).format('MM/DD/YYYY');
            }
        },
        mounted(){
            if(!this.userReport_id && localStorage.getItem('cashflowFilters')){
                this.filters = JSON.parse(localStorage.getItem('cashflowFilters'));
            }
        },
        methods: {
            metaUnique(obj){
                if(!obj) return;
                return '<span class="total-key">Unique</span><span class="total-value">' + this.$options.filters.formatInteger(obj.unique) + '</span>';
            },
            metaDollar(obj){
                if(!obj) return;

                var html = '<span class="total-key">Total</span>' +
                        '<span class="total-value">' + this.$options.filters.formatMoney(obj.total) + '</span>' +
                        '<span class="total-key">Count</span>' +
                        '<span class="total-value">' + this.$options.filters.formatInteger(obj.count) + '</span>' +
                        '<span class="total-key">Avg</span>' +
                        '<span class="total-value">' + this.$options.filters.formatMoney(obj.average) + '</span>';
                return html;

            },
            paginateClick(pageNum){
                this.filters.page = pageNum;
            },
            fetch: _.debounce(function(filters){

                var _this = this;
                var timeout = {};
                this.tableData = [];

                // data = (filters) ? Object.assign({}, filters) : this.filters;
                this.loading = true;
                var data = JSON.parse(JSON.stringify(this.filters));

                this.timer = moment().valueOf();
                data.time = this.timer;
                data.offset = this.filters.limit * (this.filters.page - 1) || 0;
                data.limit = this.filters.limit;


                _this.$send(_this, 'accountCashflow2',  data).then(r => {
                    _this.loading = false;
                    _this.tableData = r.cashflow;
                    _this.num_pages = Math.ceil(r.count / _this.filters.limit);
                    _this.meta = Object.assign({}, _this.meta, r.meta);
                    if(!_this.userReport_id){
                        localStorage.setItem('cashflowFilters', JSON.stringify(_this.filters));
                    }
                });
            }, 400),
            clearFilters(){
                localStorage.setItem('cashflowFilters', '');
                this.resetFilters();
            },
            resetFilters(){
                this.filters = {
                    search:{
                        date_posted: {
                            timeframe: '',
                            start: '',
                            end: '',
                            group: ''
                        },
                        carrier_name: '',
                        account_name: '',
                        product: '',
                        net_billed: '',
                        commission: '',
                    },
                    sort: [{
                        field: 'date_posted',
                        dir: 'DESC'
                    }],
                    columns:[],
                    limit: 25,
                    page: 1
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Cashflow.vue?47f25749